// extracted by mini-css-extract-plugin
export default {"container":"Cba-z","tab":"Dba-z","selected":"Eba-z"};